// Simple email format validation regex (można też współdzielić z loginErrorHandler)
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmailInput(email) {
  if (!email) {
    return "Please enter your email address.";
  }
  if (!emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }
  return null; // no validation errors
}

export function parseForgotPasswordError(error) {
  const status = error?.status ?? error?.response?.status;

  if (!status) {
    return "An unexpected error occurred. Please try again later.";
  }

  switch (status) {
    case 404:
      return "No account found with the provided email address.";
    case 400:
      return "Invalid request. Please check your input.";
    case 500:
      return "Server error. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Service is temporarily unavailable. Please try again later.";
    default:
      return "An error occurred. Please try again.";
  }
}
